import * as React from "react";
import {IconProps} from "@components/Icons/IconTypes";

export const MailIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 18, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 16"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="#db3700"
                    d="m12.5618 0 .2442.009a4.7574 4.7574 0 0 1 3.1909 1.516c.883.9529 1.3408 2.2253 1.2712 3.5238v5.4159c.0696 1.2984-.3882 2.571-1.2712 3.5237a4.7562 4.7562 0 0 1-3.4351 1.5251H4.6981C1.8557 15.5134 0 13.1864 0 10.4769V5.0366C0 2.3271 1.8557.0001 4.698 0h7.8638Zm-9.13 4.869a.6253.6253 0 0 1 .8781-.0985l3.5856 2.8621a1.2272 1.2272 0 0 0 1.512-.0032l3.549-2.8573.3915.4875.3922.4867-3.5547 2.8613-.0065.0057a2.4776 2.4776 0 0 1-3.059 0L7.115 8.61v-.0008L3.5304 5.748a.6256.6256 0 0 1-.0985-.879Zm9.5247-.0969a.6248.6248 0 0 1 .8781.0953.625.625 0 0 1-.0944.8789l-.7837-.9742ZM1.25 10.477c.0001 2.1546 1.4242 3.7865 3.448 3.7866h7.85a3.506 3.506 0 0 0 2.5318-1.1247 3.5573 3.5573 0 0 0 .9399-2.6253c-.0007-.0121-.0016-.0245-.0016-.0366V5.0366c0-.0122.0009-.0244.0016-.0366a3.5575 3.5575 0 0 0-.9399-2.6253 3.5076 3.5076 0 0 0-2.3527-1.1182L12.548 1.25h-7.85c-2.0238 0-3.448 1.632-3.448 3.7866v5.4403Z"
                />
            </svg>
        );
    }
);

MailIcon.displayName = "MailIcon";
